import * as hdf5 from 'jsfive';
import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { RiskScore } from '../../amplify/appsync/query';
import { readBinaryFile } from '../../amplify/s3/storage';
import { generateTimestamps } from '../../utils/plot';
import { getDatePath } from '../../utils/time';

const ECGPlot = (props: {
    internalCSN: string,
    internalMRN: string,
    afibRisk: RiskScore,
    tenant: string,
}) => {
    // const numPoints = 500; // Total number of data points to simulate
    // const ecgData = simulateECGData(numPoints);
    // const timeLabels = Array.from({ length: numPoints }, (_, i) => (i * 0.04).toFixed(2)); // Time in seconds
    const [data, setData] = useState<any>({});

    useEffect(() => {
        if (!props.afibRisk.prediction_time) {
            return;
        }

        readBinaryFile(`mrn=${props.internalMRN}/csn=${props.internalCSN}/${getDatePath(new Date(props.afibRisk.prediction_time))}/II.h5`, props.tenant).then((buffer: any) => {
            var f = new hdf5.File(buffer, "");

            const baseTime = new Date(props.afibRisk.prediction_time)
            baseTime.setSeconds(0, 0);
            let timestamps = generateTimestamps(baseTime.getTime() / 1000, 10, 125);
            const firstElement = timestamps[0];
            timestamps = timestamps.map(element => element - firstElement);

            let vals = f.get("II").value;
            // Get one of the first 10 sec ECG strips (prefer the last 10 sec to avoid initial empty regions)
            vals = vals.slice(50 * 125, (50 + 10) * 125);

            const ecg = {
                labels: timestamps,
                datasets: [
                    {
                        label: 'ECG Signal',
                        data: vals,
                        fill: false,
                        borderWidth: 1,
                        borderColor: 'black',
                        tension: 0.1,
                    },
                ],
            };
            setData(ecg);

        }).catch((ex: any) => {
            console.log("Failed to get waveforms...");
            console.log(ex);
        });
    }, [props.afibRisk]);

    const options = {
        scales: {
            x: {
                type: 'linear',
                position: 'bottom',
                title: {
                    display: true,
                    text: 'Time (seconds)',
                },
                ticks: {
                    stepSize: 0.04, // 1 mm corresponds to 0.04 sec
                    autoSkip: false,
                    callback: (value: number, index: number) => (index % 5 === 0 ? value.toFixed(2) : ''), // Show label every 0.2 seconds
                },
                grid: {
                  color: 'rgba(255, 99, 132, 0.5)',
                  lineWidth: (ctx: any) => (ctx.index % 5 === 0 ? 2 : 1), // Major grid line every 0.2 seconds (5 ticks of 0.04 each)
                },
                // Maintain square grid
                min: 0,
                max: 10,
            },
            y: {
                title: {
                    display: true,
                    text: 'Amplitude (mV)',
                },
                ticks: {
                    stepSize: 0.1, // 10 mm corresponds to 1 mV
                    autoSkip: false,
                    callback: (value: number, index: number) => (index % 5 === 0 ? value.toFixed(2) : ''),
                },
                grid: {
                    color: 'rgba(255, 99, 132, 0.5)',
                    lineWidth: (ctx: any) => (ctx.tick && ctx.tick.value % 0.5 === 0 ? 2 : 1), // Major grid line every 0.2 seconds (5 ticks of 0.04 each)
                },
                // Maintain square grid
                min: -1,
                max: 1,
            },
        },
        elements: {
            point:{
                radius: 0
            }
        },
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },
        },
        maintainAspectRatio: false, // Allow responsive design
    };

    if (!data || Object.keys(data).length === 0) {
        return <></>;
    }

    return (
        <div style={{ width: '1400px', height: '180px', textAlign: 'center', margin: '0 auto' }}>
            {/* @ts-ignore */}
            <Line data={data} options={options} />
        </div>
    );
};

export default ECGPlot;
